import {Optional} from "./types.ts";

export const SYSTEM_COOKIES = {
  TOKEN: 'token',
}

export function getCookie(key: string): Optional<string> {
  const value = document.cookie.split('; ').reduce((acc, cookie) => {
    const indexOfEqual = cookie.indexOf('=');
    if(indexOfEqual === -1) return acc;
    const name = cookie.substring(0, indexOfEqual);
    const value = cookie.substring(indexOfEqual + 1);
    return name === key ? value : acc;
  }, '');
  return value === '' ? null : value;
}

export function setCookie(key: string, value: string, expires: Date) {
  document.cookie = `${key}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Strict`;
}

export function clearCookie(key: string) {
  setCookie(key, '', new Date(0));
}